import { render, staticRenderFns } from "./ChatFlowsList.vue?vue&type=template&id=adb11952"
import script from "./ChatFlowsList.vue?vue&type=script&lang=js"
export * from "./ChatFlowsList.vue?vue&type=script&lang=js"
import style0 from "./ChatFlowsList.vue?vue&type=style&index=0&id=adb11952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports